import { Link } from 'react-router-dom';
import { ArrowRight, Quote } from 'lucide-react';

const StewardshipSection = () => {
  return (
    <section className="py-24 lg:py-32 bg-hero text-hero-text overflow-hidden relative">
      {/* Subtle background texture */}
      <div className="absolute inset-0 opacity-[0.02] bg-[radial-gradient(circle_at_50%_50%,_hsl(var(--hero-text))_1px,_transparent_1px)] bg-[length:24px_24px]" />
      
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="max-w-5xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            {/* Left: Content */}
            <div>
              <p className="font-sans text-xs tracking-ultrawide uppercase text-brass mb-4">
                The Philosophy of Stewardship
              </p>
              <h2 className="font-display text-3xl sm:text-4xl font-normal text-hero-text tracking-wide mb-6">
                Conservation Through Utilization
              </h2>
              
              <div className="space-y-4 text-hero-text/80 leading-relaxed">
                <p>
                  At the Y.O., we proved decades ago that hunting and conservation are inseparable 
                  partners. Our "Noah's Ark" was built on a simple, powerful truth: 
                  <span className="text-hero-text font-medium"> When wildlife has value, wildlife is preserved.</span>
                </p>
                <p>
                  We are the temporary gatekeepers of a legacy that began with Captain Charles Schreiner 
                  in the 1880s. To manage this land is to understand that we do not own the history—we 
                  merely harvest its lessons to ensure its future.
                </p>
              </div>

              <Link to="/stewardship" className="inline-flex items-center gap-3 mt-8 font-sans text-sm tracking-widest uppercase text-hero-text border border-hero-text/30 px-6 py-4 hover:bg-hero-text/5 hover:border-hero-text/50 transition-all duration-300 group">
                  Read the Full Philosophy
                  <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" />
              </Link>
            </div>

            {/* Right: Quote Card */}
            <div className="relative group">
              {/* Decorative corner accents */}
              <div className="absolute -top-3 -left-3 w-16 h-16 border-l border-t border-brass/20 transition-all duration-500 group-hover:w-20 group-hover:h-20 group-hover:border-brass/40" />
              <div className="absolute -bottom-3 -right-3 w-16 h-16 border-r border-b border-brass/20 transition-all duration-500 group-hover:w-20 group-hover:h-20 group-hover:border-brass/40" />
              
              <div className="bg-hero-text/5 border border-hero-text/10 p-8 lg:p-10 transition-all duration-500 group-hover:bg-hero-text/[0.07] group-hover:border-hero-text/20">
                <Quote className="w-10 h-10 text-brass/40 mb-6 transition-transform duration-500 group-hover:scale-110" />
                <blockquote className="font-serif text-xl lg:text-2xl italic text-hero-text leading-relaxed mb-6">
                  "We aren't just raising herds or hosting hunts; we are cultivating a legacy 
                  that will stand for another 150 years."
                </blockquote>
                <div className="border-t border-hero-text/10 pt-6">
                  <p className="font-medium text-hero-text">Chris Slover</p>
                  <p className="text-sm text-hero-text/60">General Partner</p>
                  <p className="text-sm text-hero-text/60">Y.O. Ranch Headquarters</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StewardshipSection;